import {PropertyRequest} from '../../../property/model/property-request.model';
import {AvailableVehicleCategory} from '../../../category/enum/available-vehicle-category.enum';

export class NewVehicleRequest {
  constructor(
    public readonly category: AvailableVehicleCategory,
    public readonly ownerId: number,
    public readonly storageId: number,
    public readonly returnDate: string | null,
    public readonly returningPerson: string,
    public readonly properties: PropertyRequest[],
  ) {
  }
}
